module.exports = __webpack_public_path__ + "assets1752041109707/img/home-img.ff28be9e.jpg";